const communityImages = [
  { src: "https://images.unsplash.com/photo-1739298061740-5ed03045b280?crop=entropy&cs=srgb&fm=jpg&q=85", alt: "A team at work" },
  { src: "https://images.unsplash.com/photo-1611432579699-484f7990b127?crop=entropy&cs=srgb&fm=jpg&q=85", alt: "A small business owner" },
  { src: "https://images.unsplash.com/photo-1607748862156-7c548e7e98f4?crop=entropy&cs=srgb&fm=jpg&q=85", alt: "Friends and allies together" },
];

export default function CommunityGrid() {
  return (
    <section className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 pb-20">
      <div className="text-center mb-10">
        <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#1E3A6E] mb-3">Who We Serve</p>
        <h2 className="font-display font-extrabold uppercase text-2xl md:text-3xl text-zinc-950 tracking-tight">
          Real people. Real communities.
        </h2>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        {communityImages.map((img) => (
          <div key={img.src} className="rounded-sm overflow-hidden border border-zinc-200 h-64">
            <img src={img.src} alt={img.alt} className="w-full h-full object-cover" />
          </div>
        ))}
      </div>
    </section>
  );
}
